import { ProductType, Product, AccommodationType } from "app/shared/model/Product";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export async function getAllProducts(publishedOnly: boolean = true) {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.products_get_all + `?publishedOnly=${publishedOnly}`, mapProduct, 'Failed to fetch products');
}

export default function mapProduct(productDto: any) : Product {
    let productType = productDto.type as string;
    let accommodationType: AccommodationType | undefined = undefined;
    
    if (productType === 'AccommodationRoom') {
        productType = ProductType.Accommodation;
        
        if (productDto.Properties?.accommodationType !== undefined) {
            accommodationType = productDto.Properties.accommodationType;
        } else if (productDto.accommodationType !== undefined) {
            accommodationType = productDto.accommodationType;
        } else if (productDto.typeId !== undefined) {
        }
    }
    
    const rawActive = productDto.active ?? productDto.Active;
    const p = {
        code: productDto.id as string,
        name: productDto.name as string,
        type: productType as ProductType,
        ...(rawActive !== undefined ? { active: rawActive === true } : {}),
        ...(accommodationType !== undefined && { accommodationType })
    } as Product

    return p;
}